import type { Router } from "vue-router"

const CHUNK_RELOAD_SESSION_KEY = "teamingapp:chunk-load-reload"

const CHUNK_LOAD_FAILURE_PATTERN =
	/loading chunk|failed to fetch dynamically imported module|importing a module script failed|unable to preload css|unexpected token </i

function getErrorMessage(error: unknown): string {
	if (error instanceof Error) {
		return error.message
	}

	if (typeof error === "string") {
		return error
	}

	return ""
}

export function isChunkLoadFailure(error: unknown): boolean {
	return CHUNK_LOAD_FAILURE_PATTERN.test(getErrorMessage(error))
}

function reloadOnceForChunkFailure(targetPath?: string): void {
	if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
		return
	}

	sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "1")

	if (targetPath) {
		window.location.assign(targetPath)
		return
	}

	window.location.reload()
}

function registerGlobalChunkLoadRecovery(): void {
	window.addEventListener("vite:preloadError", (event) => {
		event.preventDefault()
		reloadOnceForChunkFailure()
	})

	window.addEventListener("unhandledrejection", (event) => {
		if (!isChunkLoadFailure(event.reason)) {
			return
		}

		event.preventDefault()
		reloadOnceForChunkFailure()
	})
}

export function registerChunkLoadRecovery(router: Router): void {
	registerGlobalChunkLoadRecovery()

	router.onError((error, to) => {
		if (!isChunkLoadFailure(error)) {
			return
		}

		reloadOnceForChunkFailure(to.fullPath)
	})

	router.afterEach(() => {
		sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY)
	})
}
